import * as React from 'react';
import { autocompleteClasses, Button } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { styled } from '@mui/material/styles';

import { Customer } from 'types/Customer';
import { brandColors } from 'brandColors';

// Highlight on hover or keyboard navigation
const StyledOption = styled('li')(() => ({
  [`&.${autocompleteClasses.focused}`]: {
    backgroundColor: brandColors.colors.gray['700'],
    fontWeight: 'bold',
  },
}));

export type HandleToggleEdit = (e: React.MouseEvent<HTMLButtonElement>, customer: Customer) => void;

interface Props extends React.HtmlHTMLAttributes<HTMLLIElement> {
  customer: Customer;
  onToggleEdit: HandleToggleEdit;
}

export const Option: React.FC<Props> = (props) => {
  const { customer, onToggleEdit, ...rest } = props;

  const handleSettingsClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    onToggleEdit(e, customer);
  };

  return (
    <StyledOption {...rest} className="rounded px-2 py-1 my-1 h-6 flex cursor-pointer items-center">
      <h4 className="uppercase flex-grow truncate">{customer.code}</h4>
      <Button
        onClick={handleSettingsClick}
        onMouseDown={(e) => e.stopPropagation()}
        variant="text"
        color="inherit"
        size="small"
        className="p-0 m-0"
        style={{ minWidth: 'unset' }}
      >
        <MoreHorizIcon className="flex-shrink-0" />
      </Button>
    </StyledOption>
  );
};
Option.displayName = 'CustomerTag.Search.Option';
